/**
 * CUSTOMER-R5 / COMMERCE-R5.2 — open/download PDF via short-lived HTTPS access URL.
 * Must NOT navigate to blob: URLs (ERR_BLOCKED_BY_CLIENT / ad-blockers).
 * Inline preview prefers in-app PDF.js viewer (caller); this helper opens external HTTPS as fallback/download.
 */
import { mintCustomerDocumentHttpsUrl } from "./customer-document-access-v2.js";

function openHttpsUrl(httpsUrl: string): void {
  const tg = (window as unknown as { Telegram?: { WebApp?: { openLink?: (url: string) => void } } })
    .Telegram?.WebApp;
  try {
    if (tg?.openLink) {
      tg.openLink(httpsUrl);
      return;
    }
  } catch {
    /* fall through */
  }
  const opened = window.open(httpsUrl, "_blank", "noopener,noreferrer");
  if (!opened) {
    const a = document.createElement("a");
    a.href = httpsUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export async function openCustomerDocumentPdf(opts: {
  url: string;
  mode: "inline" | "download";
  filename?: string;
  lang?: "uk" | "en" | "ua";
}): Promise<{ ok: boolean; message?: string; httpsUrl?: string }> {
  const en = opts.lang === "en";
  try {
    const minted = await mintCustomerDocumentHttpsUrl({ url: opts.url, mode: opts.mode });
    if (!minted.ok) {
      return { ok: false, message: en ? minted.messageEn : minted.messageUk };
    }
    openHttpsUrl(minted.httpsUrl);
    return { ok: true, httpsUrl: minted.httpsUrl };
  } catch {
    return {
      ok: false,
      message: en ? "Could not open document." : "Не вдалося відкрити документ.",
    };
  }
}

/** Mint HTTPS URL without navigating — for in-app PDF.js viewer. */
export async function mintCustomerDocumentViewUrl(opts: {
  url: string;
  lang?: "uk" | "en" | "ua";
}): Promise<{ ok: true; httpsUrl: string } | { ok: false; message: string }> {
  const en = opts.lang === "en";
  const minted = await mintCustomerDocumentHttpsUrl({ url: opts.url, mode: "inline" });
  if (!minted.ok) {
    return { ok: false, message: en ? minted.messageEn : minted.messageUk };
  }
  return { ok: true, httpsUrl: minted.httpsUrl };
}
